

























































import moment from 'moment';
import Vue from 'vue';

interface IComputed {
  dataAvailable: boolean;
  displayValue: number;
  normalizedValue: number;
  labelColor: string;
  addedDate: string;
}

interface IProps {
  name: string;
  description: string;
  valueDescription: string;
  value: number;
  max: number;
  valueUnit: string;
  color: string;
  display: string;
}

export default Vue.extend<Record<string, unknown>, Record<string, unknown>, IComputed, IProps>({
  name: 'Statistics',

  props: {
    name: {
      type: String,
      default: 'Unknown',
    },

    description: {
      type: String,
      default: 'This value does not have a description.',
    },

    valueDescription: {
      type: String,
      default: 'Unknown',
    },

    value: {
      type: Number,
      required: true,
    },

    max: {
      type: Number,
      default: 1,
    },

    valueUnit: {
      type: String,
      default: '%',
    },

    color: {
      type: String,
      default: 'rgb(255, 196, 1)',
    },

    display: {
      type: String,
      default: 'percent',
    },
  },

  computed: {
    dataAvailable() {
      return this.value !== -1;
    },

    displayValue() {
      if (!this.dataAvailable) {
        return 0;
      }

      switch (this.display) {
        case 'percent':
          return Math.round(this.normalizedValue * 100);
        default:
          return Math.round(this.value);
      }
    },

    normalizedValue() {
      if (!this.dataAvailable) {
        return 0;
      }

      return this.value / this.max;
    },

    labelColor() {
      if (!this.dataAvailable) {
        return 'rgba(255, 255, 255, 0.267)';
      }

      return this.color;
    },

    addedDate() {
      if (!this.dataAvailable) {
        return '';
      }

      if (this.value === 0) {
        return 'Date Unknown';
      }

      return moment(this.value).format('MMM Do, YYYY');
    },
  },
});
